import React, { ReactNode, useMemo, useState } from 'react';

import { AgreementType } from '../../../redux/api/agreements/interfaces';
import {
  LocalStorageKey,
  LocalStorageService,
} from '../../../shared/storage/local-storage';
import AgreementsModal, { AgreementsModalMode } from './AgreementsModal';

interface IGuestCookieConsentGateProps {
  isAuthenticated: boolean;
  children: ReactNode;
}

const GuestCookieConsentGate = ({
  isAuthenticated,
  children,
}: IGuestCookieConsentGateProps) => {
  const [isAccepted, setIsAccepted] = useState<boolean>(() =>
    Boolean(
      LocalStorageService.getValue(LocalStorageKey.cookieConsentAccepted),
    ),
  );

  const shouldShowConsent = useMemo(
    () => !isAuthenticated && !isAccepted,
    [isAccepted, isAuthenticated],
  );

  const handleAgree = () => {
    LocalStorageService.setValue(LocalStorageKey.cookieConsentAccepted, true);
    setIsAccepted(true);
  };

  return (
    <>
      {children}
      <AgreementsModal
        open={shouldShowConsent}
        mode={AgreementsModalMode.FORCED}
        agreementType={AgreementType.COOKIE_POLICY}
        compactCookieForcedMode={true}
        onAgree={handleAgree}
        onClose={() => {}}
      />
    </>
  );
};

export default GuestCookieConsentGate;
